"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSON(json) {
    return TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSONTyped(json, false);
}
exports.TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSON = TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSON;
function TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sequenceNumber': !runtime_1.exists(json, 'sequence_number') ? undefined : json['sequence_number'],
        'createQueryPolicy': !runtime_1.exists(json, 'create_query_policy') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1CreateQueryPolicyCommandFromJSON(json['create_query_policy']),
        'updateQueryPolicy': !runtime_1.exists(json, 'update_query_policy') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1UpdateQueryPolicyCommandFromJSON(json['update_query_policy']),
        'deleteQueryPolicy': !runtime_1.exists(json, 'delete_query_policy') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1DeleteQueryPolicyCommandFromJSON(json['delete_query_policy']),
        'createTableAssociation': !runtime_1.exists(json, 'create_table_association') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1CreateTableAssociationCommandFromJSON(json['create_table_association']),
        'updateTableAssociation': !runtime_1.exists(json, 'update_table_association') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1UpdateTableAssociationCommandFromJSON(json['update_table_association']),
        'deleteTableAssociation': !runtime_1.exists(json, 'delete_table_association') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1DeleteTableAssociationCommandFromJSON(json['delete_table_association']),
        'createEntitlementRelation': !runtime_1.exists(json, 'create_entitlement_relation') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1CreateEntitlementRelationCommandFromJSON(json['create_entitlement_relation']),
        'deleteEntitlementRelation': !runtime_1.exists(json, 'delete_entitlement_relation') ? undefined : _1.TableauPublishedconnectionQuerypolicyV1DeleteEntitlementRelationCommandFromJSON(json['delete_entitlement_relation']),
    };
}
exports.TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSONTyped = TableauPublishedconnectionQuerypolicyV1CommandListItemFromJSONTyped;
function TableauPublishedconnectionQuerypolicyV1CommandListItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sequence_number': value.sequenceNumber,
        'create_query_policy': _1.TableauPublishedconnectionQuerypolicyV1CreateQueryPolicyCommandToJSON(value.createQueryPolicy),
        'update_query_policy': _1.TableauPublishedconnectionQuerypolicyV1UpdateQueryPolicyCommandToJSON(value.updateQueryPolicy),
        'delete_query_policy': _1.TableauPublishedconnectionQuerypolicyV1DeleteQueryPolicyCommandToJSON(value.deleteQueryPolicy),
        'create_table_association': _1.TableauPublishedconnectionQuerypolicyV1CreateTableAssociationCommandToJSON(value.createTableAssociation),
        'update_table_association': _1.TableauPublishedconnectionQuerypolicyV1UpdateTableAssociationCommandToJSON(value.updateTableAssociation),
        'delete_table_association': _1.TableauPublishedconnectionQuerypolicyV1DeleteTableAssociationCommandToJSON(value.deleteTableAssociation),
        'create_entitlement_relation': _1.TableauPublishedconnectionQuerypolicyV1CreateEntitlementRelationCommandToJSON(value.createEntitlementRelation),
        'delete_entitlement_relation': _1.TableauPublishedconnectionQuerypolicyV1DeleteEntitlementRelationCommandToJSON(value.deleteEntitlementRelation),
    };
}
exports.TableauPublishedconnectionQuerypolicyV1CommandListItemToJSON = TableauPublishedconnectionQuerypolicyV1CommandListItemToJSON;
